import React from 'react'
import { Grid } from '@mui/material'

export const MenuItem: React.FC<{ right?: boolean }> = ({ children, right }) => {
  const styles = {
    mr: right ? 0 : 1,
    ml: right ? 1 : 0
  }

  return (
    <Grid item {...styles}>
      {children}
    </Grid>
  )
}
